import { render, staticRenderFns } from "./PartsHeader.vue?vue&type=template&id=0ed0f868&"
import script from "./PartsHeader.vue?vue&type=script&lang=js&"
export * from "./PartsHeader.vue?vue&type=script&lang=js&"
import style0 from "./PartsHeader.vue?vue&type=style&index=0&id=0ed0f868&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports